  <template>
  <div style="padding: 10px">
    <v-form data-vv-name="createForm">
      <v-card>
        <div class="headline dialog-header" v-if="!print">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
        </div>
        <v-card-text>
          <v-layout wrap v-if="!print">
            <v-flex md2 style="padding: 10px">
              <v-select :label="$t('lang.report.warehouse')"
                        v-model.trim="report.warehouseId"
                        :items="lstWarehouse"
                        v-validate="'required'"
                        name="warehouseId"
                        :data-vv-as="$t('lang.report.warehouse')"
                        :error-messages="errors.first('warehouseId')"
                        item-text="categoryName"
                        item-value="categoryId"
                        @change="getReportData"
              />
            </v-flex>
            <v-flex md2 style="padding: 10px">
              <v-autocomplete
                  :label="$t('lang.purchase.vendor')"
                  v-model="report.vendorId"
                  :items="lstVendor"
                  item-text="partnerName"
                  item-value="partnerId"
                  name="vendorId"
                  clearable
                  :data-vv-as="$t('lang.purchase.vendor')"
                  :error-messages="errors.first('vendorId')"
                  @change="getReportData"
                  multiple
              />
            </v-flex>
            <v-flex md2 style="padding: 10px">
              <i-datepicker
                  :label="$t('lang.common.fromDate')"
                  v-model="report.fromDate"
                  v-validate="'required'"
                  name="startDate"
                  :data-vv-as="$t('lang.common.fromDate')"
                  :error-messages="errors.first('startDate')"
                  :disabled="!isEdit"
                  @change="getReportData"
                  :maxDate="maxDay()"
              />
            </v-flex>
            <v-flex md2 style="padding: 10px">
              <i-datepicker
                  :label="$t('lang.common.toDate')"
                  v-model="report.toDate"
                  v-validate="'required|endDateAfterStart'"
                  name="toDate"
                  :data-vv-as="$t('lang.common.toDate')"
                  :error-messages="errors.first('toDate')"
                  :disabled="!isEdit"
                  :maxDate="maxDay()"
                  @change="getReportData"
              />
            </v-flex>
            <v-flex md2 style="padding: 10px">
              <v-select v-if="$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR"
                        :label="$t('lang.report.form')"
                        v-model="report.form"
                        :items="lstForm"
                        item-text="formName"
                        item-value="formId"
                        v-validate="'required'"
                        name="formSelect"
                        :data-vv-as="$t('lang.report.form')"
                        :error-messages="errors.first('formSelect')"
                        @change="getReportData"
              />
            </v-flex>
            <!--                      <v-flex md2 style="padding: 10px">-->
            <!--                        <v-btn color="primary" @click="getReportData">-->
            <!--                          {{ $t("lang.common.search") }}-->
            <!--                        </v-btn>-->
            <!--                      </v-flex>-->

          </v-layout>
          <table v-else class="infomation infoTable">
            <tr>
              <td colspan="2" style="text-align: center;width: 100%" class="title">BÁO CÁO TỒN KHO</td>
            </tr>

            <tr>
              <td><label>Mã kho:</label> {{ warehouseCode }}</td>
              <td><label>Nhà cung cấp:</label> {{ getVendorInfo }}</td>
            </tr>
            <tr>
              <td><label>Từ ngày:</label> {{ report.fromDate | formatDate }}</td>
              <td><label>Đến ngày:</label> {{ report.toDate | formatDate }}</td>
            </tr>
          </table>
          <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th :rowspan="rowspan">Nhóm vật tư</th>
                  <th :rowspan="rowspan">Mã vật tư</th>
                  <th :rowspan="rowspan">Tên vật tư</th>
                  <th :rowspan="rowspan">Đơn vị</th>
                  <th :colspan="colspan" v-if="report.vendorId.length ==0 ">Tồn đầu</th>
                  <th :colspan="colspan">Nhập</th>
                  <th :colspan="colspan" v-if="report.vendorId.length ==0 ">Xuất</th>
                  <th :colspan="colspan" v-if="report.vendorId.length ==0 ">Tồn cuối</th>
                </tr>
                <tr v-if="report.form == 1">
                  <th v-if="report.vendorId.length ==0 ">Số lượng</th>
                  <th v-if="report.vendorId.length ==0 ">Thành tiền</th>
                  <th>Số lượng</th>
                  <th>Thành tiền</th>
                  <th v-if="report.vendorId.length ==0 ">Số lượng</th>
                  <th v-if="report.vendorId.length ==0 ">Thành tiền</th>
                  <th v-if="report.vendorId.length ==0 ">Số lượng</th>
                  <th v-if="report.vendorId.length ==0 ">Thành tiền</th>
                </tr>
                <template v-for="(value,name) in lstData" v-if="value != undefined">
                  <tr v-for="(item,index) in value.items">
                    <td :rowspan="value.row" v-if="index==0">{{ value.categoryName }}</td>
                    <td><a @click="openDetail(item.materialId)">{{ item.materialCode }}</a></td>
                    <td>{{ item.materialName }}</td>
                    <td>{{ item.unit }}</td>
                    <td style="text-align: right" v-if="report.vendorId.length ==0 ">
                      {{ item.openingBalanceQuantity | currency }}
                    </td>
                    <td style="text-align: right"
                        v-if="report.form ==1 && report.vendorId.length == 0">

                      {{
                        item.openingBalanceMoney |
                            currency({
                          symbol: '',
                          thousandsSeparator: '.',
                          fractionCount: 0,
                          fractionSeparator: ',',
                          symbolPosition: 'front',
                          symbolSpacing: true,
                          avoidEmptyDecimals: undefined
                        })
                      }}
                    </td>
                    <td style="text-align: right">
                      {{ item.import | currency }}
                    </td>
                    <td style="text-align: right" v-if="report.form ==1">{{
                        Math.floor(item.importMoney)|
                            currency({
                          symbol: '',
                          thousandsSeparator: '.',
                          fractionCount: 0,
                          fractionSeparator: ',',
                          symbolPosition: 'front',
                          symbolSpacing: true,
                          avoidEmptyDecimals: undefined
                        })
                      }}
                    </td>
                    <td style="text-align: right" v-if="report.vendorId.length ==0 ">
                      {{ item.export| currency }}
                    </td>
                    <td style="text-align: right"
                        v-if="report.form ==1 && report.vendorId.length == 0">

                      {{
                        item.exportMoney|
                            currency({
                          symbol: '',
                          thousandsSeparator: '.',
                          fractionCount: 0,
                          fractionSeparator: ',',
                          symbolPosition: 'front',
                          symbolSpacing: true,
                          avoidEmptyDecimals: undefined
                        })
                      }}
                    </td>
                    <td style="text-align: right" v-if="report.vendorId.length ==0 ">
                      {{ item.endingBalanceQuantity| currency }}
                    </td>
                    <td style="text-align: right"
                        v-if="report.form ==1 && report.vendorId.length == 0">

                      {{
                        item.endingBalanceMoney| currency({
                          symbol: '',
                          thousandsSeparator: '.',
                          fractionCount: 0,
                          fractionSeparator: ',',
                          symbolPosition: 'front',
                          symbolSpacing: true,
                          avoidEmptyDecimals: undefined
                        })
                      }}
                    </td>
                  </tr>
                </template>
                <tr v-if="report.form == 1" style="font-weight: bold">
                  <td colspan="4">Tổng tiền:</td>
                  <td v-if="report.vendorId.length ==0 "></td>
                  <td v-if="report.vendorId.length ==0" style="text-align: right">
                    {{
                      sumOpening| currency({
                        symbol: '',
                        thousandsSeparator: '.',
                        fractionCount: 0,
                        fractionSeparator: ',',
                        symbolPosition: 'front',
                        symbolSpacing: true,
                        avoidEmptyDecimals: undefined
                      })
                    }}
                  </td>
                  <td></td>
                  <td style="text-align: right">
                    {{
                      sumImport| currency({
                        symbol: '',
                        thousandsSeparator: '.',
                        fractionCount: 0,
                        fractionSeparator: ',',
                        symbolPosition: 'front',
                        symbolSpacing: true,
                        avoidEmptyDecimals: undefined
                      })
                    }}
                  </td>
                  <td v-if="report.vendorId.length ==0"></td>
                  <td v-if="report.vendorId.length ==0" style="text-align: right">
                    {{
                      sumExport| currency({
                        symbol: '',
                        thousandsSeparator: '.',
                        fractionCount: 0,
                        fractionSeparator: ',',
                        symbolPosition: 'front',
                        symbolSpacing: true,
                        avoidEmptyDecimals: undefined
                      })
                    }}
                  </td>
                  <td v-if="report.vendorId.length ==0"></td>
                  <td v-if="report.vendorId.length ==0" style="text-align: right">
                    {{
                      sumClose| currency({
                        symbol: '',
                        thousandsSeparator: '.',
                        fractionCount: 0,
                        fractionSeparator: ',',
                        symbolPosition: 'front',
                        symbolSpacing: true,
                        avoidEmptyDecimals: undefined
                      })
                    }}
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="!print">
          <v-spacer/>

          <v-btn color="primary" @click="onPrint">
            {{ $t("lang.report.print") }}
          </v-btn>
          <v-btn color="info" @click="onSend">
            {{ $t("lang.report.send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <send-report ref="sendDlg" @send="onSendTo"/>
    <import-export-detail :c-dialog="dialogDetail" :material-id="materialIdView" :group-data="groupData"
                          :mt-data="mtData[materialIdView]"
                          :from-date="report.fromDate"
                          :to-date="report.toDate"
                          :warehouseCode="warehouseCode"
                          :lstImportExport="lstImportExport"
                          @closeDialog="closeDetail"/>
  </div>
</template>

<script>
import axios from "axios";
import SendReport from "./SendReport";
import {message} from "@/shared/message";
import moment from "moment";
import {roleConstants} from "@/constants";
import {Validator} from "vee-validate";
import ImportExportDetail from "@/views/report/ImportExportReportDetail";

export default {
  name: "ImportExportReport",
  components: {ImportExportDetail, SendReport},
  props: {},

  data: () => {
    return {
      isEdit: true,
      report: {
        warehouseId: -1,
        vendorId: [],
        form: 1,
        fromDate: (new Date()).setDate(new Date().getDate() - 7),
        toDate: new Date()
      },
      lstWarehouse: [{"categoryId": -1, "categoryName": "Tất cả"}],
      lstVendor: [],
      lstMaterialType: [],
      lstForm: [
        {'formId': 1, 'formName': 'Có giá tiền'},
        {'formId': 2, 'formName': 'Không có giá tiền'},
      ],
      lstImport: [],
      lstExport: [],
      lstData: [],
      sumOpening: 0,
      sumImport: 0,
      sumExport: 0,
      sumClose: 0,
      loadCompleted: 0,
      print: false,
      roleConstants: [],
      groupData: [],
      mtData: {},
      dialogDetail: false,
      materialIdView: '',
      lstImportExport: [],
    };
  },

  watch: {},

  mounted() {
    Validator.extend("endDateAfterStart", {
      validate: (value, {otherValue}) => {
        let mm = moment(value).hour(23).minute(59).second(59);
        let valid = mm.isSameOrAfter(this.report.fromDate); // false
        return {
          valid: valid,
          data: {
            message: "Đến ngày phải sau Từ ngày"
          }
        };
      },
      getMessage: (field, params, data) => {
        return "Đến ngày phải sau Từ ngày";
      }
    });
    this.getWarehouse();
    this.getVendor();
    this.getMaterialType();
    this.getReportData();

  },

  computed: {
    formName() {
      return "Báo cáo Xuất Nhập kho";
    },

    rowspan() {
      if (this.report.form == 1) {
        return 2;
      } else {
        return 1;
      }
    },

    colspan() {
      if (this.report.form == 1) {
        return 2;
      } else {
        return 1;
      }
    },

    warehouseCode() {
      let code = null;
      if (this.report.warehouseId == undefined || this.report.warehouseId == null || this.report.warehouseId == -1) {
        return "Tất cả";
      }
      for (let j = 0; j < this.lstWarehouse.length; j++) {
        if (this.report.warehouseId == this.lstWarehouse[j].categoryId) {
          if (code == null) {
            code = this.lstWarehouse[j].categoryCode;
          }
          break;
        }
      }
      return code;
    },

    getVendorInfo() {
      let code = null;
      if (this.report.vendorId == undefined || this.report.vendorId == null) {
        return code;
      }
      for (let j = 0; j < this.lstVendor.length; j++) {
        if (this.report.vendorId == this.lstVendor[j].partnerId) {
          code = this.lstVendor[j].partnerName;
          break;
        }
      }

      return code;
    }

  },

  created() {
    this.roleConstants = roleConstants;
    this.report = {
      warehouseId: -1,
      vendorId: [],
      form: 1,
      fromDate: (new Date()).setDate(new Date().getDate() - 7),
      toDate: new Date()
    };
    if (this.$store.state.auth.user.role != this.roleConstants.ROLE_CONSTANTS.DIRECTOR) {
      this.report.form = 2;
    }
    if (this.$route.params.print != undefined) {
      this.print = true;
      if (this.$route.params.warehouseId == undefined || this.$route.params.warehouseId == null || this.$route.params.warehouseId == "" || this.$route.params.warehouseId == "undefined") {
        this.report.warehouseId = -1;
      } else {
        this.report.warehouseId = JSON.parse(this.$route.params.warehouseId);
      }
      if (this.$route.params.vendorId == undefined || this.$route.params.vendorId == null || this.$route.params.vendorId == "" || this.$route.params.vendorId == "undefined") {
        this.report.vendorId = [];
      } else {
        this.report.vendorId = JSON.parse(this.$route.params.vendorId);
      }
      this.report.fromDate = this.$route.params.fromDate;
      this.report.toDate = this.$route.params.toDate;
      this.report.form = parseInt(this.$route.params.form);
      console.log("this.report", this.report)
      this.getReportData();
    }
  },

  methods: {
    maxDay() {
      let day = moment().format("YYYY-MM-DD");
      return day;
    },

    getWarehouseRemain() {
      let ids = null;
      for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
        if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
          if (ids == null) {
            ids = this.requestData.lstMaterial[i].materialId;
          } else {
            ids += "," + this.requestData.lstMaterial[i].materialId;
          }
        }
      }
      //console.log(ids);
      //console.log(this.requestData);
      let url = process.env.VUE_APP_API_URL + "/warehouse/byIds?ids=" + ids;
      axios.post(url).then(
          data => {
            this.lstWarehouseItem = data;
            for (let i = 0; i < this.requestData.lstMaterial.length; i++) {
              if (this.requestData.lstMaterial[i].materialId != undefined && this.requestData.lstMaterial[i].materialId != null) {
                for (let j = 0; j < this.lstWarehouseItem.length; j++) {
                  if (this.requestData.lstMaterial[i].materialId == this.lstWarehouseItem[j].materialId) {
                    this.requestData.lstMaterial[i].remain = this.lstWarehouseItem[j].quantity;
                    if (this.requestData.lstMaterial[i].remain == undefined
                        || this.requestData.lstMaterial[i].remain == null
                        || this.requestData.lstMaterial[i].remain == "") {
                      //console.log(this.requestData.lstMaterial[h].remain);
                      this.requestData.lstMaterial[i].remain = 0;
                    }

                    this.requestData.lstMaterial[i].buyNumber = (this.requestData.lstMaterial[i].total + this.requestData.lstMaterial[i].reserved) - parseFloat(this.requestData.lstMaterial[i].remain);
                    this.requestData.lstMaterial[i].buyNumber = parseFloat(this.requestData.lstMaterial[i].buyNumber.toFixed(2));
                    if (this.requestData.lstMaterial[i].buyNumber < 0) {
                      this.requestData.lstMaterial[i].buyNumber = 0;
                    }
                    this.requestData.lstMaterial[i].buyNumberPropose = this.requestData.lstMaterial[i].buyNumber;
                    break;
                  }
                }
              }
            }
            this.$forceUpdate();
          }
      )
    },

    getWarehouse() {
      axios.post(process.env.VUE_APP_API_URL + "/category/myWarehouse").then(
          data => {
            this.lstWarehouse.push(...data);
          }
      )
    },

    getVendor() {
      axios.post(process.env.VUE_APP_API_URL + "/partner/search?sortField=partnerName&pageSize=-1&page=-1", {status: 1}).then(
          data => {
            this.lstVendor = data.items;
          }
      )
    },
    openDetail(id) {
      this.dialogDetail = true;
      this.materialIdView = id;
      this.lstImportExport = [];
      if (this.groupData == undefined) {
        return;
      }
      
      for (let i = 0; i < this.groupData.length; i++) {
        let objGroupData = this.groupData[i];
        let objImportExport = new Object();
        objImportExport.date = objGroupData.date;
        objImportExport.type = objGroupData.type;
        objImportExport.exportType = objGroupData.item.exportType;
        objImportExport.warehouseId = objGroupData.item.warehouseId;

        if (objImportExport.type == "export") {
          objImportExport.requestNumber = objGroupData.item.requestNumber;
          objImportExport.cropCode = objGroupData.item.cropCode;
        } else if (objImportExport.type == "import") {
          objImportExport.requestNumber = objGroupData.item.importNumber;
          objImportExport.content = objGroupData.item.content;
        }
        let listMaterialData = objGroupData.item.data;
        if(objGroupData.item == undefined || objGroupData.item.data == undefined){
          continue;
        }
        for (let i = 0; i < listMaterialData.length; i++) {
          let obj = listMaterialData[i];
          if (parseInt(obj.materialId) == parseInt(id)) {
            objImportExport.materialName = obj.materialName;
            objImportExport.materialCode = obj.materialCode;
            objImportExport.typeId = obj.typeId;
            objImportExport.typeName = obj.typeName;
            if (objImportExport.type == "export") {
              objImportExport.quantityExport = obj.total_export;
              objImportExport.priceExport = obj.price;
              objImportExport.amountExport = obj.amount;
              if (objImportExport.exportType == 1) {
                objImportExport.content = "vật tư nuôi theo quy trình";
              } else {
                objImportExport.content = obj.content;
              }
            } else if (objImportExport.type == "import") {
              objImportExport.quantityImport = obj.actualImport;
              objImportExport.priceImport = obj.price;
              objImportExport.amountImport = obj.amount;
            }
            this.lstImportExport.push(objImportExport);
            break;
          }
        }

      }
      
      this.lstImportExport = this.getImportExportFromDateToDate(this.lstImportExport).slice();
      this.lstImportExport = this.sumSameRequestNumber(this.lstImportExport).slice();
      this.lstImportExport = this.setWarehouseToList(this.lstImportExport).slice();
      console.log(this.lstImportExport);
    },
    getImportExportFromDateToDate(lstImportExport) {
      let lst = new Array();
      for (let i = 0; i < lstImportExport.length; i++) {
        let obj = lstImportExport[i];
        let mm = moment(obj.date).hour(0).minute(0).second(0);
        if (mm.isSameOrAfter(this.report.fromDate) && mm.isSameOrBefore(this.report.toDate)) {
          lst.push(obj);
        }
      }
      return lst;

    },
    sumSameRequestNumber(lstImportExport) {
      let lst = new Array();
      for (let i = 0; i < lstImportExport.length; i++) {
        let obj = lstImportExport[i];
        let pos = this.getPositionHaveSameRequestNumber(lst, obj);
        if (pos == -1) {
          lst.push(obj);
        } else {
          lst[pos].quantityExport = this.nvl(lst[pos].quantityExport) + this.nvl(obj.quantityExport);
          lst[pos].amountExport = this.nvl(lst[pos].amountExport) + this.nvl(obj.amountExport);
        }
      }
      return lst;

    },
    setWarehouseToList(lstImportExport) {
      let lst = new Array();
      for (let i = 0; i < lstImportExport.length; i++) {
        let obj = lstImportExport[i];
        for (let j = 0; j < this.lstWarehouse.length; j++) {
          if (obj.warehouseId == this.lstWarehouse[j].categoryId) {
            obj.warehouseCode = this.lstWarehouse[j].categoryCode;
            obj.warehouseName = this.lstWarehouse[j].categoryName;
            break;
          }
        }
        lst.push(obj);
      }
      //alert(JSON.stringify(lst))
      return lst;

    },
    nvl(value) {
      if (value == undefined) {
        return 0;
      } else {
        return value;
      }
    },
    getPositionHaveSameRequestNumber(lst, obj) {
      for (let i = 0; i < lst.length; i++) {
        if (lst[i].requestNumber != undefined && lst[i].requestNumber == obj.requestNumber) {
          return i;
        }
      }
      return -1;
    },

    closeDetail() {
      this.dialogDetail = false;
    },

    getReportData() {
      this.loadCompleted = 0;
      this.getImportData();
      this.getExportData();
    },

    getImportData() {
      let report = {
        warehouseId: this.report.warehouseId,
        toDate: this.report.toDate
      }
      axios.post(process.env.VUE_APP_API_URL + "/importWh/searchReport?page=-1&pageSize=-1", report).then(
          data => {
            this.lstImport = data.items;
            for (let i = 0; i < this.lstImport.length; i++) {
              this.lstImport[i].data = JSON.parse(this.lstImport[i].requestData);
            }
            this.loadCompleted += 1;
            this.calculateData();
          }
      )

    },

    getExportData() {
      let report = {
        warehouseId: this.report.warehouseId,
        status: 5, // trang thai da hoan thanh
        toDate: this.report.toDate
      }
      axios.post(process.env.VUE_APP_API_URL + "/exportRequest/searchReport", report).then(
          data => {
            this.lstExport = data;
            for (let i = 0; i < this.lstExport.length; i++) {
              this.lstExport[i].data = JSON.parse(this.lstExport[i].exportData);
              if (this.lstExport[i].exportType == 1 && this.lstExport[i].session != null) {
                //console.log("--- dn theo quy trinh co session != null ---");
                let session = this.lstExport[i].session;
                //console.log(session);

                //linhdx khong can set lai total_export lam gi
                // for(let j=0;j<this.lstExport[i].data.length;j++){
                //     let item = this.lstExport[i].data[j];
                //     //console.log(item);
                //     if(this.lstExport[i].session<=12){
                //         if (item.quantityAm != undefined && item.quantityAm != null && item.quantityAm.length > 0) {
                //             for (let k = 0; k < item.quantityAm.length; k++) {
                //                 if (item.quantityAm[k].time == session && !isNaN(item.quantityAm[k].value)) {
                //                     item.total_export = parseFloat(item.quantityAm[k].value);
                //                     //console.log("---update herre---");
                //                     break;
                //                 }
                //             }
                //         }
                //
                //     } else {
                //         if (item.quantityPm != undefined && item.quantityPm != null && item.quantityPm.length > 0) {
                //             for (let k = 0; k < item.quantityPm.length; k++) {
                //                 if (item.quantityPm[k].time == session && !isNaN(item.quantityPm[k].value)) {
                //                     item.total_export = parseFloat(item.quantityPm[k].value);
                //                     //console.log("---update herre---");
                //                     break;
                //                 }
                //             }
                //         }
                //
                //     }
                // }
                //linhdx khong can set lai total_export lam gi END
              }
              /*
              if(this.lstExport[i].exportedTime != null && this.lstExport[i].exportedTime != ""){
                  this.lstExport[i].exported = JSON.parse("["+ this.lstExport[i].exportedTime + "]");
              } else {
                  this.lstExport[i].exported = null;
              }
              for(let j=0;j<this.lstExport[i].data.length;j++){
                  let item = this.lstExport[i].data[j];
                  item.total_exported = 0;
                  if(this.lstExport[i].exported != null){
                      for(let h=0;h<this.lstExport[i].exported.length;h++){
                          let hour =  this.lstExport[i].exported[h];
                          if(hour<=12) {
                              if (item.quantityAm != undefined && item.quantityAm != null && item.quantityAm.length > 0) {
                                  for (let k = 0; k < item.quantityAm.length; k++) {
                                      if (item.quantityAm[k].time == hour && isNaN(item.quantityAm[k].value)) {
                                          item.total_exported += parseFloat(item.quantityAm[k].value);
                                      }
                                  }
                              }
                          } else {
                              if (item.quantityPm != undefined && item.quantityPm != null && item.quantityPm.length > 0) {
                                  for (let k = 0; k < item.quantityPm.length; k++) {
                                      if (item.quantityPm[k].time == hour && isNaN(item.quantityPm[k].value)) {
                                          item.total_exported += parseFloat(item.quantityPm[k].value);
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
*/
            }
            this.loadCompleted += 2;
            this.calculateData();
          }
      )
    },

    calculateData() {
      console.log("this.loadCompleted", this.loadCompleted)
      if (this.loadCompleted != 3 && this.loadCompleted != 6) {
        //
        // not completed chua tinh
        //
        return;
      }

      this.lstData = [];

      let checkMC = 'MVS02';
      //console.log("--- recalculate data ---");
      //console.log(this.lstMaterialType);
      console.log("lstImport", this.lstImport);
      console.log("lstExport", this.lstExport);
      let mtData = {};
      let fromDate = new Date(new Date(this.report.fromDate).setHours(0, 0, 0));
      let toDate = new Date(new Date(this.report.toDate).setHours(23, 59, 59));
      let bCheckVendor = false;
      if (this.report.vendorId != undefined && this.report.vendorId != null && this.report.vendorId != [] && this.report.vendorId.length > 0) {
        bCheckVendor = true;
      }
      let groupData = [];
      for (let i = 0; i < this.lstImport.length; i++) {
        let ob = {
          item: this.lstImport[i],
          type: "import",
          date: new Date(this.lstImport[i].dateArrived)
        }
        groupData.push(ob);
      }
      for (let i = 0; i < this.lstExport.length; i++) {
        let ob = {
          item: this.lstExport[i],
          type: "export",
          date: new Date(this.lstExport[i].toDate)
        }
        groupData.push(ob);
      }

      groupData.sort((a, b) => {
        return a.date.getTime() - b.date.getTime();
      });
      console.log("groupData", groupData);
      //linhdx
      this.groupData = groupData;
      for (let i = 0; i < groupData.length; i++) {
        let item = groupData[i].item;
        let receiveDate = groupData[i].date;
        //console.log(receiveDate);
        if(!item.data){
          continue;
        }
        for (let j = 0; j < item.data.length; j++) {
          if (bCheckVendor) {
            let bHas = false;
            for (let h = 0; h < this.report.vendorId.length; h++) {
              if (this.report.vendorId[h] == item.data[j].supplyId) {
                bHas = true;
                break;
              }
            }
            if (!bHas) {
              continue;
            }
          }
          if (item.data[j].materialCode == checkMC) {
            console.log("checkMC",item.data[j].totalImportQuantityAcc + "-" + item.data[j].money);
          }
          if (groupData[i].type == "import") {
            //console.log("import");
            if (item.data[j].actualImport == null || item.data[j].actualImport == "" || isNaN(item.data[j].actualImport)) {
              item.data[j].actualImport = 0;
            }
            if (item.data[j].amount == null || item.data[j].amount == "" || isNaN(item.data[j].amount)) {
              item.data[j].amount = 0;
            }
            if (item.data[j].materialId != undefined && item.data[j].materialId != null) {
              if (mtData[item.data[j].materialId] == undefined || mtData[item.data[j].materialId] == null) {
                let mt = Object.assign({}, item.data[j]);
                mtData[item.data[j].materialId] = mt;
                if (receiveDate >= fromDate && receiveDate <= toDate) {
                  mt.import = parseFloat(item.data[j].actualImport);
                  mt.importMoney = parseFloat(item.data[j].amount);
                } else {
                  mt.import = 0;
                  mt.importMoney = 0;
                }
                mt.export = 0;
                mt.exportMoney = 0;

                if (receiveDate < fromDate) {
                  mt.openingBalanceQuantity = parseFloat(item.data[j].actualImport);
                  mt.openingBalanceMoney = parseFloat(item.data[j].amount);
                } else {
                  mt.openingBalanceQuantity = 0;
                  mt.openingBalanceMoney = 0;
                }
                mt.endingBalanceQuantity = parseFloat(item.data[j].actualImport);
                mt.endingBalanceMoney = parseFloat(item.data[j].amount);
                mt.price = mt.endingBalanceMoney / mt.endingBalanceQuantity;
                //console.log(mt);
                //console.log(mt.endingBalanceQuantity);
              } else {
                let mt = mtData[item.data[j].materialId];
                if (receiveDate >= fromDate && receiveDate <= toDate) {
                  mt.import += parseFloat(item.data[j].actualImport);
                  mt.importMoney += parseFloat(item.data[j].amount);
                }

                if (receiveDate < fromDate) {
                  mt.openingBalanceQuantity += parseFloat(item.data[j].actualImport);
                  mt.openingBalanceMoney += parseFloat(item.data[j].amount);
                }
                mt.endingBalanceQuantity += parseFloat(item.data[j].actualImport);
                mt.endingBalanceMoney += parseFloat(item.data[j].amount);
                mt.price = mt.endingBalanceMoney / mt.endingBalanceQuantity;
                //console.log(mt.endingBalanceQuantity);
              }
            }
          } else {

            //console.log(item.data[j].total_export);

            if (item.data[j].total_export == null || item.data[j].total_export == "" || isNaN(item.data[j].total_export)) {
              item.data[j].total_export = 0;
            }
            if (item.data[j].materialCode == checkMC) {
              console.log("checkMC export ",item.data[j].total_export + "-" + item.data[j].price);
            }
            if (mtData[item.data[j].materialId] == undefined || mtData[item.data[j].materialId] == null) {
              let mt = Object.assign({}, item.data[j]);

              mtData[item.data[j].materialId] = mt;
              mt.import = 0;
              mt.importMoney = 0;
              mt.price = 0;
              if (receiveDate >= fromDate && receiveDate <= toDate) {
                mt.export = parseFloat(item.data[j].total_export);
                console.log("item", item);
                console.log("item.data[j].total_export", item.data[j].total_export);
                console.log("mt.export", mt.export);
                mt.exportMoney = mt.export * mt.price;
              } else {
                mt.export = 0;
                mt.exportMoney = 0;
              }

              if (receiveDate < fromDate) {
                mt.openingBalanceQuantity = -1 * parseFloat(item.data[j].total_export);
                mt.openingBalanceMoney = mt.openingBalanceQuantity * mt.price;
              } else {
                mt.openingBalanceQuantity = 0;
                mt.openingBalanceMoney = 0;
              }
              mt.endingBalanceQuantity = -1 * parseFloat(item.data[j].total_export);
              //linhdx fix do pice luc do tinh trung binh khong dung
              //mt.endingBalanceMoney = mt.endingBalanceQuantity * mt.price;
              mt.endingBalanceMoney = -1 * parseFloat(item.data[j].amount);
              //console.log(mt.endingBalanceQuantity);
            } else {
              let mt = mtData[item.data[j].materialId];
              if (receiveDate >= fromDate && receiveDate <= toDate) {
                mt.export += parseFloat(item.data[j].total_export);
                mt.exportMoney += parseFloat(item.data[j].amount);
              }
              if (receiveDate < fromDate) {
                mt.openingBalanceQuantity -= parseFloat(item.data[j].total_export);
                mt.openingBalanceMoney = mt.openingBalanceQuantity * mt.price;
              }
              mt.endingBalanceQuantity -= parseFloat(item.data[j].total_export);
              //linhdx fix
              //mt.endingBalanceMoney = mt.endingBalanceQuantity * mt.price;
              mt.endingBalanceMoney -= parseFloat(item.data[j].amount);
              if (item.data[j].materialCode == checkMC) {
                console.log("checkMC price ", mt);
                console.log("checkMC price 22222", item.data[j]);
              }
              //console.log(receiveDate);
              //console.log(mt.endingBalanceQuantity);
            }
          }
        }
      }
      console.log("mtdata", mtData);
      this.mtData = mtData;
      /*
                      for (let i = 0; i < this.lstImport.length; i++) {
                          let receiveDate = new Date(this.lstImport[i].dateArrived);
                          for (let j = 0; j < this.lstImport[i].data.length; j++) {
                              if (bCheckVendor) {
                                  let bHas = false;
                                  for (let h = 0; h < this.report.vendorId.length; h++) {
                                      if (this.report.vendorId[h] == this.lstImport[i].data[j].supplyId) {
                                          bHas = true;
                                          break;
                                      }
                                  }
                                  if (!bHas) {
                                      continue;
                                  }
                              }
                              if (this.lstImport[i].data[j].materialCode == checkMC) {
                                  console.log(this.lstImport[i].data[j].totalImportQuantityAcc + "-" + this.lstImport[i].data[j].money);
                              }
                              if (this.lstImport[i].data[j].materialId != undefined && this.lstImport[i].data[j].materialId != null) {
                                  if (mtData[this.lstImport[i].data[j].materialId] == undefined || mtData[this.lstImport[i].data[j].materialId] == null) {
                                      let mt = Object.assign({}, this.lstImport[i].data[j]);
                                      mtData[this.lstImport[i].data[j].materialId] = mt;
                                      if (receiveDate >= fromDate && receiveDate <= toDate) {
                                          mt.import = parseFloat(this.lstImport[i].data[j].orderQuantity);
                                          mt.importMoney = parseFloat(this.lstImport[i].data[j].money);
                                      } else {
                                          mt.import = 0;
                                          mt.importMoney = 0;
                                      }
                                      mt.export = 0;
                                      mt.exportMoney = 0;

                                      if (receiveDate < fromDate) {
                                          mt.openingBalanceQuantity = parseFloat(this.lstImport[i].data[j].orderQuantity);
                                          mt.openingBalanceMoney = parseFloat(this.lstImport[i].data[j].money);
                                      } else {
                                          mt.openingBalanceQuantity = 0;
                                          mt.openingBalanceMoney = 0;
                                      }
                                      mt.endingBalanceQuantity = parseFloat(this.lstImport[i].data[j].orderQuantity);
                                      mt.endingBalanceMoney = parseFloat(this.lstImport[i].data[j].money);
                                      mt.price = mt.endingBalanceMoney / mt.endingBalanceQuantity;
                                  } else {
                                      let mt = mtData[this.lstImport[i].data[j].materialId];
                                      if (receiveDate >= fromDate && receiveDate <= toDate) {
                                          mt.import += parseFloat(this.lstImport[i].data[j].orderQuantity);
                                          mt.importMoney += parseFloat(this.lstImport[i].data[j].money);
                                      }

                                      if (receiveDate < fromDate) {
                                          mt.openingBalanceQuantity += parseFloat(this.lstImport[i].data[j].orderQuantity);
                                          mt.openingBalanceMoney += parseFloat(this.lstImport[i].data[j].money);
                                      }
                                      mt.endingBalanceQuantity += parseFloat(this.lstImport[i].data[j].orderQuantity);
                                      mt.endingBalanceMoney += parseFloat(this.lstImport[i].data[j].money);
                                      mt.price = mt.endingBalanceMoney / mt.endingBalanceQuantity;
                                  }
                              }
                          }

                      }
                      console.log("--- export ---");
                      for (let i = 0; i < this.lstExport.length; i++) {
                          let exportDate = new Date(this.lstExport[i].exportDate);
                          for (let j = 0; j < this.lstExport[i].data.length; j++) {
                              if (this.lstExport[i].data[j].materialId != undefined && this.lstExport[i].data[j].materialId != null) {
                                  if (bCheckVendor) {
                                      let bHas = false;
                                      for (let h = 0; h < this.report.vendorId.length; h++) {
                                          if (this.report.vendorId[h] == this.lstExport[i].data[j].supplyId) {
                                              bHas = true;
                                              break;
                                          }
                                      }
                                      if (!bHas) {
                                          continue;
                                      }
                                  }

                                  if (this.lstExport[i].data[j].materialCode == checkMC) {
                                      //console.log(exportDate);
                                      //console.log(this.lstExport[i].data[j].total_export);
                                  }

                                  if (mtData[this.lstExport[i].data[j].materialId] == undefined || mtData[this.lstExport[i].data[j].materialId] == null) {
                                      let mt = Object.assign({}, this.lstExport[i].data[j]);
                                      mtData[this.lstExport[i].data[j].materialId] = mt;
                                      mt.import = 0;
                                      mt.importMoney = 0;
                                      mt.price = 0;
                                      if (exportDate >= fromDate && exportDate <= toDate) {
                                          mt.export = parseFloat(this.lstExport[i].data[j].total_export);
                                          mt.exportMoney = mt.export * mt.price;
                                      } else {
                                          mt.export = 0;
                                          mt.exportMoney = 0;
                                      }

                                      if (exportDate < fromDate) {
                                          mt.openingBalanceQuantity = -1 * parseFloat(this.lstExport[i].data[j].total_export);
                                          mt.openingBalanceMoney = mt.openingBalanceQuantity * mt.price;
                                      } else {
                                          mt.openingBalanceQuantity = 0;
                                          mt.openingBalanceMoney = 0;
                                      }
                                      mt.endingBalanceQuantity = -1 * parseFloat(this.lstExport[i].data[j].total_export);
                                      mt.endingBalanceMoney = mt.endingBalanceQuantity * mt.price;
                                  } else {
                                      let mt = mtData[this.lstExport[i].data[j].materialId];
                                      if (exportDate >= fromDate && exportDate <= toDate) {
                                          mt.export += parseFloat(this.lstExport[i].data[j].total_export);
                                          mt.exportMoney = mt.export * mt.price;
                                      }
                                      if (exportDate < fromDate) {
                                          mt.openingBalanceQuantity -= parseFloat(this.lstExport[i].data[j].total_export);
                                          mt.openingBalanceMoney = mt.openingBalanceQuantity * mt.price;
                                      }
                                      mt.endingBalanceQuantity -= parseFloat(this.lstExport[i].data[j].total_export);
                                      mt.endingBalanceMoney = mt.endingBalanceQuantity * mt.price;
                                  }
                              }
                          }
                      }
      */

      for (let key in mtData) {
        let typeId = mtData[key].typeId;
        if (this.lstData[typeId] == undefined || this.lstData[typeId] == null) {
          this.lstData[typeId] = this.lstMaterialType.filter(item => {
            return item.categoryId == typeId;
          })[0];
          this.lstData[typeId].row = 1;
          this.lstData[typeId].items = [mtData[key]];
        } else {
          this.lstData[typeId].items.push(mtData[key]);
          this.lstData[typeId].row = this.lstData[typeId].items.length;
        }
      }
      console.log(this.lstData);
      //
      // sum
      //
      this.sumOpening = 0;
      this.sumImport = 0;
      this.sumExport = 0;
      this.sumClose = 0;
      for (let key in this.lstData) {
        let items = this.lstData[key].items;
        for (let i = 0; i < items.length; i++) {
          if (!isNaN(items[i].openingBalanceMoney)) {
            this.sumOpening += items[i].openingBalanceMoney;
          }
          if (!isNaN(items[i].importMoney)) {
            this.sumImport += items[i].importMoney;
          }
          if (!isNaN(items[i].exportMoney)) {
            this.sumExport += items[i].exportMoney;
          }

          if (!isNaN(items[i].endingBalanceMoney)) {
            this.sumClose += items[i].endingBalanceMoney;
          }


          //console.log(items[i].exportMoney);
        }
      }

      if (this.print) {
        this.$nextTick(
            () => {
              window.print();
            }
        )
      }
      console.log("--- end recalculate ---");

    },

    getMaterialType() {
      //let url = process.env.VUE_APP_API_URL + "/category/listByTypeAndCode?type=MATERIAL_TYPE&code=VTN";
      let url = process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE";

      axios.post(url).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
            }
          }
      );
    },

    onCancel() {
      // this.createDlg = false;
      // this.onSearch();
      this.$emit("cancel");
    },

    onSend() {
      this.$refs.sendDlg.onShow();
    },

    generateReportURL() {
      let url = "/print/importExportReport/1/";
      url += JSON.stringify(this.report.warehouseId) + "/";
      url += JSON.stringify(this.report.vendorId) + "/";
      url += this.report.fromDate + "/";
      url += this.report.toDate + "/";
      url += this.report.form;
      return url;
    },

    onSendTo(user) {
      console.log('--- send to user');
      console.log(user);
      let url = process.env.VUE_APP_FRONTEND_URL + "/#" + this.generateReportURL();
      let report = {
        reportType: 'Báo cáo xuất nhập kho',
        userId: user.userId,
        url: url
      };
      axios.post(process.env.VUE_APP_API_URL + "/report/sendReport", report).then(
          data => {
            if (data.success) {
              message.success("Gửi thành công");
              this.$refs.sendDlg.onCancel();
            } else {
              message.error("Gửi không thành công");
            }
          }
      );
    },

    onPrint() {
      let url = this.generateReportURL();
      this.$router.push(url);
    }
  },

  destroyed() {
  },
};
</script>
